import React from "react";
import { Box, Typography } from "@mui/material";

// Import assets from EnquireySection
import newYorkImg from "../../Assets/EnquireySection/Newyork.png";
import hyderabadImg from "../../Assets/EnquireySection/hyderbad.png";

const OfficesSection = () => {
  const offices = [
    { label: "HEADQUARTERS", name: "HYDERABAD", image: hyderabadImg },
    { label: "REGIONAL OFFICE", name: "UNITED STATES", image: newYorkImg },
  ];

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography
        sx={{
          fontFamily: "Manrope, sans-serif",
          fontWeight: 600,
          fontSize: { xs: "32px", md: "40px" },
          color: "#1C1B1B",
          textAlign: "center",
          mb: 6,
        }}
      >
        Our Global Offices
      </Typography>
      
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 4, md: 6 },
          width: "100%",
        }}
      >
      {offices.map((office, idx) => (
        <Box
          key={idx}
          sx={{
            width: "362.66px",
            height: "300px",
            borderRadius: "8px",
            boxShadow: "2px 2px 10px 0px rgba(0, 0, 0, 0.25)",
            overflow: "hidden",
            position: "relative",
            cursor: "pointer",
            "&:hover .office-image": {
              transform: "scale(1.05)",
            },
          }}
        >
          {/* Image taking up the entire card */}
          <Box
            component="img"
            className="office-image"
            src={office.image}
            alt={`${office.name} Office`}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          />
          {/* Gradient Overlay for Text Readability */}
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              height: "50%",
              background: "linear-gradient(to top, rgba(0,0,0,0.8), transparent)",
            }}
          />
          {/* Text Overlay */}
          <Box
            sx={{
              position: "absolute",
              bottom: "24px",
              left: "24px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                fontSize: "10px",
                color: "#E7E5E4", // Light gray
                textTransform: "uppercase",
                letterSpacing: "1px",
                mb: "4px",
              }}
            >
              {office.label}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "20px",
                lineHeight: "28px",
                width: "157.38px",
                textAlign: "left",
                verticalAlign: "middle",
                color: "#FFFFFF",
                textTransform: "uppercase",
              }}
            >
              {office.name}
            </Typography>
          </Box>
        </Box>
      ))}
      </Box>
    </Box>
  );
};

export default OfficesSection;
